import AppError from "@utils/AppError";

export interface ServiceError {
  message: string;
  variant: "error" | "warning" | "info" | "success";
}

export interface ServiceResult<T> {
  data: T | null;
  error: ServiceError | null;
}

export async function safeExecute<T>(
  fn: () => Promise<T>,
  fallbackMessage: string
): Promise<ServiceResult<T>> {
  try {
    const data = await fn();
    return { data, error: null };
  } catch (error) {
    if (error instanceof AppError) {
      return {
        data: null,
        error: { message: error.message, variant: error.variant },
      };
    }
    return {
      data: null,
      error: { message: fallbackMessage, variant: "error" },
    };
  }
}
